<template>
  <div v-if="visible" class="hero-benefits">
    <button type="button" class="hero-benefits-close" :aria-label="$t('Zavrieť')" @click="visible = false">
      <img src="../../assets/icons/close.svg" alt="">
    </button>
    <BenefitTiles :items="items" variant="blue" clickable @select="$emit('select', $event)" />
  </div>
</template>

<script>
import BenefitTiles from "@/components/shared/BenefitTiles";

export default {
  name: "HeroBenefits",
  components: {BenefitTiles},
  props: {
    // [{ icon: 'nabytok', label: '...' }] alebo [{ highlight: '10/90', label: '...' }]
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      visible: true
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
$large: 1180px

.hero-benefits
  position: absolute
  right: 70px
  bottom: 40px
  z-index: 10
  padding-top: 26px

  // na menších obrazovkách by panel prekryl text v hero, presúva sa hore (ako sticker na homepage)
  @media (max-width: $large)
    bottom: auto
    top: 110px
    right: 50px

  @media (max-width: $md)
    top: 90px
    left: 16px
    right: 16px

.hero-benefits-close
  position: absolute
  top: 0
  right: 0
  width: 22px
  height: 22px
  padding: 5px
  border: 0
  border-radius: 2px
  background: rgba(255, 255, 255, 0.85)
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer

  img
    width: 100%

  &:hover
    background: #fff

</style>
